module.exports = __webpack_public_path__ + "static/home-sm-61c470b2df0b5ae636b3f24b78e3d35e.jpg";